import { render, staticRenderFns } from "./zCompartilharContas.vue?vue&type=template&id=af3d25ba&scoped=true&"
import script from "./zCompartilharContas.vue?vue&type=script&setup=true&lang=js&"
export * from "./zCompartilharContas.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af3d25ba",
  null
  
)

export default component.exports